import {
  COMMON_STATUS,
  ELESSON_DETAIL,
  ERESULT,
  ESTATUS_LEARNING,
  EVISIBILITY,
  VISIBILITY,
} from "./enum";
export * from "./chat";
export * from "./enum";
export * from "./notifications";
export * from "./socket";

export const DEFAULT_ERROR_MESSAGE = "エラーです。再試行してください。";
export const DEFAULT_SUCCESS_MESSAGE = "操作が成功しました。";

export type Pagination = {
  page: number;
  pageSize: number;
  itemCount: number;
  pageCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
};

// API related types
export type ApiResponse<T> = {
  data: T;
  status: number;
  statusCode?: number;
  message?: string;
  pagination?: Pagination;
};

export type ApiErrorResponse = {
  message: string;
  statusCode: number;
  error: string;
};

export enum RoleEnum {
  SUPER_ADMIN = "super",
  COMPANY_ADMIN = "admin",
  HEAD_OFFICE_USER = "head",
  STORE_MANAGER = "store",
  USER = "user",
  OTHER = "other",
}

export enum ECOMPANY_BUSINESS {
  JATMA = "JATMA",
  MANUFACTURER = "メーカー",
  WHOLESALE = "卸",
  TS_RETAIL = "TS（小売）",
  CS_RETAIL = "CS（小売）",
  OTHER = "その他",
}

export enum ECOMPANY_SERIES {
  BS = "BS",
  D = "D",
  Y = "Y",
  B_SERIES = "B系列",
  D_SERIES = "D系列",
  T_SERIES = "T系列",
  T = "T",
  MICHELIN = "ミシュラン",
  GOODYEAR = "グッドイヤー",
  PIRELLI = "ピレリ",
  CONTINENTAL = "コンチネンタル",
  HANKOOK = "ハンコック",
  KUMHO = "クムホ",
  NEXEN = "ネクセン",
  NANKANG = "ナンカン",
  AUTOBACS = "オートバックス",
  YELLOW_HAT = "イエローハット",
  JAMES_TMP = "ジェームス（TMP)",
  TAIYAKAN_COCKPIT = "タイヤ館/コクピット",
  AUTOLAND_TIRE_SELECT_TIRELAND = "オートランド/タイヤセレクト/タイヤランド",
  TIRE_GARDEN_GRAND_SLAM = "タイヤガーデン/グランドスラム",
  LANDMARK_TIRE_PRO = "ランドマーク/タイヤプロ",
  MISTER_TIRE_MAN = "ミスタータイヤマン",
  FUJI_CORPORATION = "フジ・コーポレーション",
  AUTO_ARZ = "オートアールズ",
  AUTO_WAVE = "オートウェーブ",
  AUTOWAY = "AUTOWAY",
  AUTOWAY_SEKICHU = "オートウェイ（セキチュー）",
  TIRE_WORLD_KAN_BEST = "タイヤワールド館ベスト",
  CARPORT_MARUZEN = "カーポートマルゼン",
  ZENTAKYOREN = "全タ協連",
  CHOKSETSU_OROSHI = "直接卸",
  CHOKSETSU_KOURI = "直接小売",
  OTHER = "その他",
}

export enum BusinessTypeEnum {
  MEMBER = "会員",
  NON_MEMBER = "非会員",
}

export enum ELEVEL_QUIZ {
  BEGINNER = "BEGINNER",
  EXPERT = "EXPERT",
}

export type CommonParams<T> = {
  search?: string;
  s?: string;
  page?: number;
  limit?: number;
  isPagination?: 1 | 0;
  order?: "DESC" | "ASC";
  orderBy?: "id" | "createdAt";
  isDeleted?: 1 | 0;
  withDeleted?: 1 | 0;
} & T;

export type CompanyDto = {
  name: string;
  address: string;
  phone: string;
  deleted_at: string | null;
  updated_at: string;
  created_at: string;
  id: number;
  prefecture_id: number;
  business_user_id: number;
  business_type: string;
  business_code: BusinessTypeEnum;
  corporate_code: string;
  email: string;
  representative_position: string;
  status: "ENABLE" | "DISABLE";
  series: string;
  business: string;
  post_code: string;
  joining_date: string;
  unsubscribe_date: string;
  store_display_name: string;
  note: string;
  logo_image: string | null;
  report_history: string | null;
  store_inspection_history: string | null;
};

export type PrefectureDto = {
  label: string;
  value?: number;
  key?: number;
}[];

export type OptionDto = {
  key: number;
  label: string;
};

export type CreateGroupDto = {
  name: string;
  companyId: number;
  storeIds: number[];
};

export type CreateMyGroupDto = {
  name: string;
  storeIds: number[];
};

export type StoreDto = {
  name: string;
  phone: string;
  address: string;
  company_id: number;
  deleted_at: string | null;
  updated_at: string;
  created_at: string;
  id: number;
  group_id: number;
  status: "ENABLE" | "DISABLE";
  company: CompanyDto | null;
  group: StoreGroupDto | null;
  report_history?: string;
  store_inspection_history?: string;
  user: {
    deleted_at: string | null;
    updated_at: string;
    created_at: string;
    id: number;
    store_id: number;
    role_id: number;
    company_id: number;
    user_name: string;
    email: string;
    full_name: string;
    password: string;
    is_admin: boolean;
    status: "ENABLE" | "DISABLE";
    address: string;
    phone: string;
    sale_office: string | null;
    position: string | null;
    department: string | null;
    role: {
      deleted_at: string | null;
      updated_at: string;
      created_at: string;
      id: number;
      name: string;
      description: string | null;
    };
  }[];
};

export type StoreGroupDto = {
  deleted_at: string | null;
  updated_at: string;
  created_at: string;
  id: number;
  name: string;
  company_id: number;
  description: string;
};

export type GetCompanyParams = CommonParams<{
  business_type?: BusinessTypeEnum;
  s?: string;
}>;

export type CompanyParams = {
  business_type: BusinessTypeEnum;
  name: string;
  business_code?: string;
  corporate_code?: string;
  series?: string;
  business?: string;
  prefecture_id?: number;
  post_code?: string;
  representative_position?: string;
  address?: string;
  phone?: string;
  email?: string;
  joining_date?: string;
  unsubscribe_date?: string;
  store_display_name?: string;
  note?: string;
  business_user?: {
    role: RoleEnum.COMPANY_ADMIN;
    sale_office?: string;
    position?: string;
    department?: string;
    phone?: string;
    full_name?: string;
    email: string;
    password: string;
  };
};

export type StoreParams = {
  name: string;
  address?: string;
  role: RoleEnum;
  username: string;
  position?: string;
  department?: string;
  email: string;
  password: string;
  company_id: number;
  group_id?: number;
  sale_office?: string;
};

// User related types
export interface User {
  id: number;
  full_name: string;
  phone: null | string;
  email: string;
  position: string;
  department: string;
  address: null | string;
  image: null | string;
  role: {
    id: number;
    name: string;
  };
  company: {
    id: number;
    name: string;
  };
}

export interface Address {
  street: string;
  suite: string;
  city: string;
  zipcode: string;
  geo: Geo;
}

export interface Geo {
  lat: string;
  lng: string;
}

// Store related types
export interface UserStore {
  // State
  users: User[];
  currentUser: User | null;
  userProfile: UserProfileDto | null;
  loading: boolean;
  error: string | null;

  // Actions
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setUsers: (users: User[]) => void;
  setCurrentUser: (user: User | null) => void;
  setUserProfile: (profile: any) => void;
  // Async actions
  fetchUsers: () => Promise<User[]>;
  fetchUserById: (id: number) => Promise<User>;
  fetchUserProfile: () => Promise<void>;
  createUser: (userData: Partial<User>) => Promise<User>;
  updateUser: (id: number, userData: Partial<User>) => Promise<User>;
  deleteUser: (id: number) => Promise<void>;
  // Reset functions
  clearError: () => void;
  clearCurrentUser: () => void;
  resetStore: () => void;
}

export interface PerfectureStore {
  prefectures: PrefectureDto;
  loading: boolean;
  error: string | null;
  // Actions
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setPrefectures: (prefectures: PrefectureDto) => void;
  fetchPrefectures: () => Promise<void>;
  // Reset functions
  clearError: () => void;
  clearPrefecture: () => void;
  resetStore: () => void;
}

// Form related types
export interface UserFormData {
  name: string;
  username: string;
  email: string;
  phone: string;
  website: string;
  company: string;
  street: string;
  city: string;
  zipcode: string;
}

// Component props types
export interface UserListProps {
  onUserSelect?: (userId: number) => void;
}

export interface UserDetailProps {
  userId: number;
  onBack: () => void;
}

export interface UserFormProps {
  visible: boolean;
  onCancel: () => void;
  editUser?: User | null;
}

// Route params
export interface UserDetailParams {
  id: string;
}

// Menu item type
export interface MenuItem {
  key: string;
  icon: React.ReactNode;
  label: React.ReactNode;
}

// Switch component props
export interface SwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  className?: string;
  label?: string;
  size?: "sm" | "md" | "lg";
}

export type LessonDetailBlockDto = {
  content: string | null;
  content_type: ELESSON_DETAIL;
  is_active: boolean;
  order: number;
  lesson_id: number;
  deleted_at: string | null;
  updated_at: string | null;
  created_at: string | null;
  id: number;
};
export interface UserLessonDto {
  lesson_id: number;
  user_id: number;
  status: ESTATUS_LEARNING;
  result: null;
  updated_at: string;
  created_at: string;
  id: number;
  lesson: {
    title: string;
    description: string;
    image: string;
    quiz_id: null;
    deleted_at: null;
    updated_at: string;
    created_at: string;
    id: number;
    unit_id: number;
    status: EVISIBILITY;
  };
}

export type LessonDto = {
  id: number;
  image: string | null;
  title: string;
  unit_id: number;
  isDone?: boolean;
};

export type LessonUnitDto = {
  title: string;
  id: number;
  created_at: string;
  lessons: LessonDto[];
};

export type UnitsDto = {
  unit: {
    title: string;
    deleted_at: null;
    updated_at: string;
    created_at: string;
    id: 33;
  };
  data: {
    title: string;
    description: string;
    image: string;
    quiz_id: number | null;
    deleted_at: null;
    updated_at: string;
    created_at: string;
    id: number;
    unit_id: number;
    status: VISIBILITY;
    units: null;
  }[];
};

export type LessonDetailDto = {
  title: string;
  description: string | null;
  image: string | null;
  quiz_id: number | null;
  deleted_at: string | null;
  updated_at: string | null;
  created_at: string | null;
  id: number;
  unit_id: number | null;
  status: VISIBILITY;
  quiz_status?: ESTATUS_LEARNING;
  progress_status: ESTATUS_LEARNING;
  quiz?: {
    status: VISIBILITY;
  };
  units: {
    title: string;
    deleted_at: string | null;
    updated_at: string | null;
    created_at: string | null;
    id: number;
  } | null;
  lessonDetail: LessonDetailBlockDto[];
  user_studied: number | null;
};

export type QuestionDto = {
  question: string;
  correct_option: string[];
  multi_result: boolean;
  mark: number;
  order: number;
  option_a: string;
  option_b: string;
  option_c: string;
  option_d: string;
  id?: number;
  answers?: {
    id: number;
    is_correct: boolean;
    selected_option: string[];
  }[];
};

export interface UserQuizDto {
  quiz_id: number;
  user_id: number;
  marks_obtained: number;
  status: ESTATUS_LEARNING;
  result: ERESULT;
  deleted_at: null;
  updated_at: string;
  created_at: string;
  id: number;
  quiz: {
    deleted_at: null;
    updated_at: string;
    created_at: string;
    id: number;
    quiz_category_id: number;
    title: string;
    description: string;
    image: string;
    status: EVISIBILITY;
    type: ELEVEL_QUIZ;
    questions: any[];
  };
  score: string;
  totalQuestions: number;
}

export type QuizDto = {
  id: number;
  title: string;
  image: string | null;
  quiz_category_id: number;
  result?: "PASSED" | "FAILED";
  marks_obtained?: number | null;
  total_questions?: number | null;
  user_quiz_id?: number | null;
  passing_score?: number | null;
  status?: EVISIBILITY;
  isDone?: boolean;
};

export type QuizCategoryDto = {
  id: number;
  title: string;
  quizzes: QuizDto[];
};

export type SubmitQuiz = {
  quiz_id: number;
  answers: {
    question_id: number;
    selected_options: string[];
  }[];
};

export interface UserDto {
  id: number;
  company_id?: number;
  role: { id: number; name: RoleEnum };
  store_id?: number;
  user_name?: string;
  email?: string;
}

export type UserProfileDto = {
  id: number;
  user_name: null | string;
  store_id: null | string;
  company_id: number;
  email: string;
  role: {
    id: number;
    name: RoleEnum;
  };
};

export type GetStoresResp = {
  id: number;
  name: string;
  address: string;
  group: {
    id: number;
    name: string;
  };
  phone: string;
  status: "ENABLE" | "DISABLE";
  report_history?: string;
  store_inspection_history?: string;
};

export type GetUsersResp = {
  id: number;
  full_name: string;
  email: string;
  role: string;
  status: "ENABLE" | "DISABLE";
  group_ids: number[];
};

export type GetGroupsRespDto = {
  deleted_at: null;
  updated_at: string;
  created_at: string;
  id: number;
  name: string;
  company_id: number;
  description: string;
  stores: {
    name: string;
    phone: string | null;
    address: string;
    company_id: number;
    deleted_at: string | null;
    updated_at: string;
    created_at: string;
    id: number;
    group_id: number;
    status: "ENABLE" | "DISABLE";
  }[];
};

export type CreateUserDto = {
  email: string;
  full_name?: string;
  user_name: string;
  password: string;
  role_id?: number;
  role?: string;
  company_id?: number;
  store_id?: number | null;
  is_admin?: boolean;
  address?: string;
  phone?: string;
  sale_office?: string;
  position?: string;
  department?: string;
  group_ids?: number[];
};

export interface UserInStore {
  id: number;
  full_name: string;
  email: string;
  role: RoleEnum;
  quiz_completed: number;
  lesson_completed: number;
  status: COMMON_STATUS;
}

export type UpdateUserResponse = {
  id: number;
  store_id: number;
  company_id: number;
  email: string;
  full_name: string;
  address: string;
  phone: string;
  position: string;
  department: string;
  image: string | null;
  role: {
    id: number;
    name: RoleEnum;
  };
};

export type UpdateUserDto = {
  email: string;
  full_name: string;
  role: RoleEnum;
  address: string;
  phone: string;
  sale_office: string;
  position: string;
  department: string;
  group_ids: number[];
};

export interface UserInfor {
  id: number;
  email: string;
  phone: string;
  address: string;
  company: {
    id: number;
    name?: string;
  };
  department: string | null;
  full_name: string;
  position: string;
  image: string | null;
  role: {
    id: number;
    name: RoleEnum;
  };
  store: {
    id: number;
    name?: string;
  };
  groups?: {
    id: number;
    group_id: number;
  }[];
  status?: COMMON_STATUS;
}
